import { Bell, CheckCircle } from 'lucide-react'
import React, { useState, useEffect } from 'react'
import { apiCall } from '../Apis/apiCall';

const Notification = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch notifications from API
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        setLoading(true);
        const response = await apiCall('GET', '/get-all-notifications');
        
        if (response && response.data) {
          setNotifications(response.data.data || response.data);
        }
      } catch (err) {
        console.error('Error fetching notifications:', err);
        setError('Failed to load notifications');
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  // Function to format time (you can customize this based on your API response format)
  const formatTime = (timestamp) => {
    if (!timestamp) return 'Just now';
    
    const now = new Date();
    const notificationTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - notificationTime) / (1000 * 60));
    
    if (diffInMinutes < 60) {
      return `${diffInMinutes} Mins ago`;
    } else if (diffInMinutes < 1440) {
      const hours = Math.floor(diffInMinutes / 60);
      return `${hours} Hours ago`;
    } else {
      const days = Math.floor(diffInMinutes / 1440);
      return `${days} Days ago`;
    }
  };

  // Function to get user avatar or initials
  const getAvatar = (notification) => {
    if (notification.user_avatar || notification.avatar) {
      return (
        <img
          src={notification.user_avatar || notification.avatar}
          alt=""
          className="w-100 h-100 rounded-circle"
        />
      );
    } else if (notification.user_name || notification.name) {
      const name = notification.user_name || notification.name;
      const initials = name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
      return initials;
    } else {
      return <CheckCircle className='icon text-xxl' />;
    }
  };

  return (
    <div className='dropdown'>
      <button
        className='has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center'
        type='button'
        data-bs-toggle='dropdown'
      >
        <Bell className='text-primary-light text-xl' />
      </button>
      <div className='dropdown-menu to-top dropdown-menu-lg p-0'>
        <div className='m-16 py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
          <div>
            <h6 className='text-lg text-primary-light fw-semibold mb-0'>
              Notifications
            </h6>
          </div>
          <span className='text-primary-600 fw-semibold text-lg w-40-px h-40-px rounded-circle bg-base d-flex justify-content-center align-items-center'>
            {loading ? '...' : notifications.length.toString().padStart(2, '0')}
          </span>
        </div>
        
        <div className='max-h-400-px overflow-y-auto scroll-sm pe-4'>
          {loading ? (
            <div className='text-center py-20'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : error ? (
            <div className='text-center py-20 text-danger'>
              <p>{error}</p>
            </div>
          ) : notifications && notifications.length > 0 ? (
            notifications.map((notification, index) => (
              <a
                key={notification.id || index}
                href='#'
                className={`px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between ${
                  !notification.is_read ? 'bg-neutral-50' : ''
                }`}
              >
                <div className='text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>
                  <span className={`w-44-px h-44-px ${
                    notification.type === 'success' ? 'bg-success-subtle text-success-main' : 
                    notification.type === 'info' ? 'bg-info-subtle text-info-main' :
                    'bg-success-subtle text-success-main'
                  } rounded-circle d-flex justify-content-center align-items-center flex-shrink-0`}>
                    {getAvatar(notification)}
                  </span>
                  <div>
                    <h6 className='text-md fw-semibold mb-4'>
                      {notification.title || notification.subject || 'Notification'}
                    </h6>
                    <p className='mb-0 text-sm text-secondary-light text-w-200-px'>
                      {notification.message || notification.body || notification.content}
                    </p>
                  </div>
                </div>
                <span className='text-sm text-secondary-light flex-shrink-0'>
                  {formatTime(notification.created_at || notification.timestamp)}
                </span>
              </a>
            ))
          ) : (
            <div className='text-center py-20 text-secondary-light'>
              <Bell className='text-4xl mb-3 opacity-50' />
              <p>No notifications yet</p>
            </div>
          )}
        </div>
        
        {/* <div className='text-center py-12 px-16'>
          <a
            href='#'
            className='text-primary-600 fw-semibold text-md'
          >
            See All Notification
          </a>
        </div> */}
      </div>
    </div>
  )
}

export default Notification